import { validateTestCardFlag } from '@/helpers/Validation/cardFlag';

export class PurchaseCard {
  public id = null;
  public card_number = null;
  public card_holder_name = null;
  public card_expiration_date = null;
  public card_cvv = null;
  public card_installment = null;
  public card_flag = null;
  public card_first_digits = null;
  public card_last_digits = null;
  public status = null;
  public is_default = null;
  public token = null;

  constructor(card: any) {
    this.id = card.id;
    this.card_number = card.card_number;
    this.card_holder_name = card.card_holder_name;
    this.card_expiration_date = card.card_expiration_date;
    this.card_cvv = card.card_cvv;
    this.card_installment = card.card_installment;
    this.card_flag = card.card_flag;
    this.card_first_digits = card.card_first_digits;
    this.card_last_digits = card.card_last_digits;
    this.status = card.status;
    this.is_default = card.is_default;
    this.token = card.token;
  }

  static fromNewCard(newCard: any): PurchaseCard {
    const firstEightDigits = newCard.card_number.replace(/\s/g, '').match(/.{1,8}/g)[0];
    const eachFourSplited = newCard.card_number.replace(/\s/g, '').match(/.{1,4}/g);
    const lastFour = eachFourSplited[eachFourSplited.length - 1];

    const card = new PurchaseCard({
      card_number: newCard.card_number.replace(/\s/g, ''),
      card_holder_name: newCard.owner_name,
      card_expiration_date: newCard.expiration_date,
      card_cvv: newCard.cvv,
      card_flag: validateTestCardFlag(newCard.card_number.replace(/\s/g, '')) ? 'mastercard' : newCard.card_flag,
      card_first_digits: firstEightDigits,
      card_last_digits: lastFour,
      token: newCard.token,
    });

    return card;
  }

}
